<template>
  <div class="file-manage-container clipboard-body">
    <tips v-if="showUploadTips" tip-class="upload-tips" placement="bottom-center" @tips-closed="closeTipsHandle">在这里也可以拖拽文件直接上传哦~</tips>

    <el-card class="file-manage-card" shadow="hover" body-style="height:calc(100% - 40px)">
      <!-- <el-button type="text">返回</el-button> -->
      <div class="file-directory-box">
        <div class="file-directory all link" @click.stop="goBack">全部</div>
        <div class="file-directory link" v-for="item in filePaths" :key="item.path" @click="goDirectory(item.path)">
          /{{ item.name }}
        </div>
        <el-popover placement="left" width="200" trigger="hover">
          <el-button class="file-directory search" type="text" icon="el-icon-search" slot="reference"></el-button>
          <el-autocomplete prefix-icon="el-icon-search" value-key="name" v-model="fileName" :fetch-suggestions="querySearch" placeholder="请输入文件名称" :trigger-on-focus="false" clearable></el-autocomplete>
        </el-popover>
        <el-tooltip class="file-directory uploads" effect="dark" content="上传文件" placement="bottom">
          <el-upload name="file_data" :multiple="true" action="/api/uploadCos" :show-file-list="false" :data="{ path }" :on-success="successHandle">
            <el-button type="text" icon="el-icon-upload2 upload-button"></el-button>
          </el-upload>
        </el-tooltip>
        <el-tooltip class="file-directory folder" effect="dark" content="上传文件夹" placement="bottom">
          <el-button type="text" class="iconfont icon-folder-upload-fill" @click.stop="showUploadFolder"></el-button>
        </el-tooltip>
        <el-tooltip class="file-directory add" effect="dark" content="新建文件夾" placement="bottom">
          <el-button type="text" icon="el-icon-folder-add" @click.stop="showDirectoryDialog"></el-button>
        </el-tooltip>
        <el-tooltip class="file-directory clock" effect="dark" content="提示" placement="bottom">
          <el-button type="text" icon="el-icon-alarm-clock" @click.stop="showNotice"></el-button>
        </el-tooltip>
        <el-tooltip class="file-directory reading" effect="dark" content="切换视图" placement="bottom">
          <el-button type="text" icon="el-icon-reading" @click.stop="changeCardView"></el-button>
        </el-tooltip>
      </div>
      <el-upload ref="xps-upload" name="file_data" drag :multiple="true" action="/api/uploadCos" :show-file-list="false" :data="{ path }" :on-success="successHandle" class="xps-upload">
        <div class="files-list">
          <virtual-scroll v-show="!isShowCard" :data="uniqueTableData" :item-size="63" key-prop="path" @change="(renderData) => virtualList = renderData">
            <el-table v-el-table-infinite-scroll="load" @row-dblclick="rowDoubleClick" :data="virtualList" :height="height" :row-class-name="tableRowClassName">
              <div class="empty-content empty-image" slot="empty">
                <p class="empty-text">将文件拖拽到此处~</p>
              </div>
              <el-table-column width="20px">
              </el-table-column>
              <el-table-column label="文件名称" prop="name" sortable min-width="400px">
                <template v-slot="{ row }">
                  <div class="file-content file-page-container">
                    <!-- <img v-if="row.isImg" class="file-image" :src="row.sourcePath" /> -->
                    <img v-if="row.isImg" class="file-image" :src="row.path" fit="contain" />
                    <div v-else class="file-image file-icon" :class="`file-icon-${row.ext}`"></div>
                    <span class="file-name">{{ row.name }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="修改时间" sortable :formatter="dateFormatter" :sort-method="dateSort">
              </el-table-column>
              <el-table-column prop="size" label="大小" sortable>
                <template v-slot="{ row }">{{ getSize(row.size) }}</template>
              </el-table-column>
              <el-table-column width="300" prop="operate" label="操作">
                <template v-slot="{ row }">
                  <el-tooltip effect="dark" content="复制图片webp格式地址" placement="left">
                    <el-button v-if="!row.isDirectory & row.isImg" type="text" v-clipboard:copy="row.path + '?imageMogr2/format/webp'" v-clipboard:success="onCopy">webp</el-button>
                  </el-tooltip>
                  <el-button v-if="!row.isDirectory" type="text" v-clipboard:copy="row.path" v-clipboard:success="onCopy">复制</el-button>
                  <el-button v-if="!row.isDirectory" type="text" @click="downloadFile(row)">下载</el-button>
                  <el-button v-if="!row.isDirectory" type="text" @click="collectFile(row)">收藏</el-button>
                  <el-button v-if="!row.isDirectory" type="text" @click="showDetail(row)">详情</el-button>
                  <el-button v-if="!row.isDirectory && userInfo.isAdmin" type="text" @click="deleteFile(row)">删除</el-button>
                  <el-button v-if="!row.isDirectory & row.isImg" type="text" @click="showImageHandle(row)">图片处理</el-button>
                </template>
              </el-table-column>
            </el-table>
          </virtual-scroll>
          <file-card v-infinite-scroll="load" v-show="isShowCard" :data="uniqueTableData" @openDirectory="rowDoubleClick" @downloadFile="downloadFile" @showFileDetail="showDetail" @imageHandle="showImageHandle" @deleteFile="deleteFile" :height="height" :name="name" :latestUploadFiles="latestUploadFiles"></file-card>
        </div>
      </el-upload>
    </el-card>

    <!-- 对话框 -->
    <el-dialog :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent">
      <component @getDirectoryFiles="getDirectoryFiles" :is="dialog.component" @close="destroyComponent" :path="path" :data="fileData" :row="row" :imageInfo="imageInfo" :name.sync="name" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { fileManageApi, xpsApi, myFilesApi } from "@/api/index";
import { isImg, getExt } from "@/common/utils/ext.js";
import { getFileSize } from "@/common/utils/size.js";
import { antiShake } from "@/common/utils/timerUtil.js";
import { getNumberName } from "@/common/utils/getHashName.js";
import { downloadFile } from "@/common/utils/download.js";
import { showLoading, hideLoading } from "@/plugins/loading";
import { dialogMixin } from "@/common/mixins/";
import tips from "@/components/Tips/index.vue";
import directoryForm from "./components/directoryForm.vue";
import uploadFolder from "./components/uploadFolder.vue";
import fileCard from "./components/fileCard.vue";
import fileDetail from "./components/fileDetail.vue";
import imageHandle from "./components/imageHandle.vue";
import dayjs from "dayjs";
import VirtualScroll from "el-table-virtual-scroll";
export default {
  mixins: [dialogMixin],
  components: {
    fileCard,
    tips,
    VirtualScroll
  },
  data () {
    return {
      path: "",
      tableData: [],
      filePaths: [],
      height: "100%",
      isShowCard: false,
      count: 0,
      fileData: null,
      noticeList: [
        {
          position: "top-right",
          title: "webp图片（降本增效）",
          message:
            "使用webp格式的图片比原图要减少40%左右的大小，并且图片渲染速度更快，但是需要注意webp格式的兼容性问题哦！为了提高CDN资源命中率，防止CDN回源：请不要在webp格式后面增加动态参数，例如：时间戳。",
          iconClass: "el-icon-picture-outline-round system-font-color",
          customClass: "text-left",
          showClose: true,
          offset: 138,
          duration: 14000,
        },
        {
          position: "top-right",
          title: "上传警告",
          message: "当批量上传同名文件时，会默认覆盖原来的文件！",
          type: "warning",
          customClass: "text-left",
          showClose: true,
          offset: 138,
        },
        {
          position: "top-right",
          title: "刷新提示",
          message:
            "当上传同名文件之后，需要刷新文件CDN地址，新的文件才会立马生效！",
          iconClass: "el-icon-refresh system-font-color",
          customClass: "text-left",
          showClose: true,
          offset: 138,
          duration: 5000,
        },
        {
          position: "top-right",
          title: "缓存提醒",
          message: "即使刷新了CDN地址，别忘记了还有浏览器缓存哦！",
          iconClass: "el-icon-loading system-font-color",
          customClass: "text-left",
          showClose: true,
          offset: 138,
          duration: 5000,
        },
        {
          position: "top-right",
          title: "刷新CDN次数",
          message: "每天只有5次刷新CDN的机会，刷新CDN地址时要慎重慎重再慎重！",
          iconClass: "el-icon-time system-red-color",
          customClass: "text-left",
          showClose: true,
          offset: 138,
          duration: 5000,
        },
      ],
      fileName: "",
      name: "",
      isFirstRender: true,
      oldUid: "",
      isLoad: false,
      lastFileKey: "",
      newValue: "",
      oldValue: "",
      arrayLength: 0,
      latestUploadFiles: [],
      row: null,
      imageInfo: null,
      virtualList: []
    };
  },
  watch: {
    path () {
      this.latestUploadFiles = []; // 重置最近上传文件
    },
  },
  computed: {
    ...mapGetters([
      "showDetailNotice",
      "showUploadTips",
      "userInfo",
      "allBtnReturnRouter",
    ]),
    filterList () {
      let result = [];
      if (this.fileName) {
        result = this.tableData.filter(
          (item) =>
            item.name.toLowerCase().indexOf(this.fileName.toLowerCase()) === 0
        );
      } else {
        result = this.tableData;
      }
      return result;
    },
    uniqueTableData () {
      let obj = {};
      let data = this.filterList.reduce((cur, next) => {
        obj[next.path] ? "" : (obj[next.path] = true && cur.push(next));
        return cur;
      }, []);
      return data;
    },
  },
  mounted () {
    this.path = this.$route.query.path;
    this.firstPathReady = true;
    this.name = this.$route.query.name;
    this.addFilePath();
    this.getDirectoryFiles();
    this.preventDefault();
    window.addEventListener("resize", () => {
      this.onWindowResize();
    });
    // 保证不刷新页面（vuex不更新）只触发通知一次（频繁跳转详情路由不触发通知）
    if (this.showDetailNotice) {
      this.showNotice();
      this.$store.commit("config/SET_SHOW_DETAIL_NOTICE", false);
    }
    this.isShowCard =
      localStorage.getItem("isShowCard") &&
      JSON.parse(localStorage.getItem("isShowCard"));
    this.bindPaste();
    this.$nextTick(() => {
      this.height = `${document.documentElement.clientHeight - 230}px`;
    });
  },
  beforeDestroy () {
    window.removeEventListener("resize", () => {
      this.onWindowResize();
    });
  },
  methods: {
    // 格式化时间
    dateFormatter (row) {
      return this.formatTime(row.lastModified);
    },
    // 排序
    dateSort (a, b) {
      return +new Date(a.lastModified) - +new Date(b.lastModified);
    },
    // 收藏文件
    async collectFile (row) {
      const res = await myFilesApi.addFavoriteFile({ filePath: row.path });
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    // 删除文件
    deleteFile (data) {
      showLoading();
      this.$confirm(
        `请确定删除该文件，此操作是直接删除COS资源。  （删除文件请在文件查找中查看/恢复）`,
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const res = await fileManageApi.deleteFile({ path: data.path });
          if (res.code === 200) {
            this.getDirectoryFiles();
            this.$message.success("文件已删除，请注意CDN文件缓存！");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });

      hideLoading();
    },
    // 显示图片处理弹窗
    async showImageHandle (row) {
      const { data } = await axios.get(`${row.path}?imageInfo`);
      data.width = data.width - 0;
      data.height = data.height - 0;
      this.imageInfo = data;
      this.row = row;
      this.setDialog(true, "图片处理", imageHandle, "1000px", "5vh");
    },
    //绑定粘贴事件
    bindPaste () {
      //定义变量存储获取的图片内容
      let file = null;
      //获取clipboardBody对象
      let clipboardBody = document.querySelector(".clipboard-body");
      //定义clipboardBody标签绑定的粘贴事件处理函数
      let fun = async (e) => {
        //获取clipboardData对象
        let data = e.clipboardData || window.clipboardData;
        let date = +new Date();
        //获取文件对象
        file = data.items[0].getAsFile();
        if (file && file.size) {
          const uid = getNumberName(`${this.path}${file.name}${file.size}`); // 以路径、文件名称、文件大小作为
          // 判断是否是粘贴板的截屏
          if (file.name === "image.png") {
            // 以时间戳重新命名文件
            file = new File([file], `${getNumberName(date)}.png`);
          }
          // 如果已经上传 返回
          if (this.oldUid === uid) {
            return this.$message.warning("当前文件已经上传了哦~");
          }
          this.oldUid = uid;
          // 上传服务器
          const form = new FormData();
          // 文件对象
          form.append("file_data", file);
          form.append("path", this.path);
          let data = await xpsApi.uploadCos(form);
          if (data) {
            this.latestUploadFiles.push(data);
            this.getDirectoryFiles();
            return this.$message.success("文件上传成功！");
          } else {
            return this.$message.error("文件上传出错啦！！");
          }
        } else {
          this.$message.warning("不支持复制空文件或文件夹哦~");
        }
      };
      //通过clipboardBody绑定粘贴事件
      clipboardBody.removeEventListener("paste", fun);
      clipboardBody.addEventListener("paste", fun);
    },
    // 给搜索的行增加样式
    tableRowClassName ({ row, rowIndex }) {
      if (row.name === this.name || this.latestUploadFiles.includes(row.path)) {
        return "system-red-color warning-row";
      }
      return "";
    },
    querySearch (queryString, cb) {
      const result = this.tableData.filter(
        (item) =>
          item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      );
      cb(result);
    },
    // 显示通知
    showNotice () {
      const index = this.count % this.noticeList.length;
      if (!this.count) {
        setTimeout(() => {
          this.showNotice();
        }, 800);
      }
      this.$notify(this.noticeList[index]);
      this.count++;
    },
    async showDetail (data) {
      showLoading();
      const res = await fileManageApi.getFileDetail({ path: data.path });
      if (res.code === 200) {
        res.data.isImg = isImg(res.data.url);
        res.data.ext = getExt(res.data.url);
        res.data.file = data || {};
        this.fileData = res.data;
        this.setDialog(true, "文件详情", fileDetail, "800px", "15vh");
      } else {
        this.$message.error(
          "请求文件详情时发生错误啦，该文件在该环境上找不到哦~"
        );
      }
      hideLoading();
    },
    // 显示新增目录对话框
    showDirectoryDialog () {
      this.setDialog(true, "新增目录", directoryForm, "40%", "15vh");
    },
    // 显示上传文件夹对话框
    showUploadFolder () {
      this.setDialog(true, "上传文件夹", uploadFolder, "70%", "15vh");
    },
    // 切换卡片视图
    changeCardView () {
      this.isShowCard = !this.isShowCard;
      window.localStorage.setItem("isShowCard", this.isShowCard);
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    // 监听窗口变化
    onWindowResize () {
      this.$nextTick(() => {
        this.height = `${document.documentElement.clientHeight - 230}px`;
      });
    },
    // 阻止默认点击上传事件
    preventDefault () {
      const uploadDom = document.querySelector(".xps-upload");
      if (uploadDom) {
        uploadDom.onclick = function (e) {
          e.preventDefault();
          return false;
        };
      }
    },
    // 文件上传成功的钩子
    successHandle (response) {
      if (response.success) {
        // 增加最近上传文件
        this.latestUploadFiles.push(response.data);
        this.$message.success("文件上传成功！");
        // 防抖--防止每次都调用获取目录文件列表
        antiShake(this.getDirectoryFiles, 500);
      } else {
        this.$message.error(response.data.message);
      }
    },
    // 返回之前页面
    goBack () {
      this.$router.push(`/${this.allBtnReturnRouter}`);
    },
    // 跳转到指定目录
    goDirectory (path) {
      this.$router.push(`/fileManage/projectDetail?path=${path}`);
      this.path = path;
      this.name = this.$route.query.name;
      this.removeFilePath();
      this.getDirectoryFiles();
    },
    // 双击表格行触发
    rowDoubleClick (row) {
      if (row.isDirectory) {
        this.$router.push(`/fileManage/projectDetail?path=${row.path}`);
        this.path = this.$route.query.path;
        this.name = "";
        this.addFilePath();
        this.getDirectoryFiles();
      } else {
        this.showDetail(row);
      }
    },
    // 移除文件路径
    removeFilePath () {
      this.filePaths = [];
      const paths = this.path.split("/");
      const filePaths = [];
      // 去除数组前面的 '/' 'custom'
      paths.shift();
      paths.shift();
      // 去除数组后面的 '/'
      paths.pop();
      let path = "/custom/";
      paths.forEach((item) => {
        const obj = {};
        path += `${item}/`;
        obj.name = item;
        obj.path = path;
        filePaths.push(obj);
      });
      this.filePaths = filePaths;
    },
    // 新增路径
    addFilePath () {
      const paths = this.path.split("/");
      // 如果是正常打开项目路径  没有搜索文件和不是第一次渲染
      if (!this.name && !this.isFirstRender) {
        const obj = {};
        obj.path = this.path;
        obj.name = paths[paths.length - 2];
        this.filePaths.push(obj);
      } else {
        let path = "/custom/";
        // 去除数组前后多余的项
        paths.splice(0, 2);
        paths.splice(paths.length - 1, 2);
        // 拼接目录路径
        paths.forEach((item, index) => {
          const obj = {};
          path = path + item + "/";
          obj.path = path;
          obj.name = paths[index];
          this.filePaths.push(obj);
        });
        this.isFirstRender = false;
      }
    },
    // 复制
    onCopy () {
      this.$message.success("文件地址复制成功", 2);
    },
    // 获取文件大小
    getSize (size) {
      if (size !== "-") {
        return getFileSize(size);
      } else {
        return size;
      }
    },
    // 格式化时间
    formatTime (time) {
      if (time) {
        return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "-";
      }
    },
    // 下载
    async downloadFile (file) {
      downloadFile(file.path, file.name);
    },
    // 查询当前目录下的文件
    async getDirectoryFiles () {
      showLoading();
      const res = await fileManageApi.getDirectoryFiles({ path: this.path });
      if (res.code === 200) {
        this.oldValue = this.newValue;
        if (res.data.length > 0) {
          this.lastFileKey = `${this.path}${res.data[res.data.length - 1].name
            }`.substring(1);
        }
        let directoryCount = 0;
        res.data.forEach((item, index) => {
          // 格式化数据
          item.size = item.size - 0;
          // 如果有正在搜索的文件或者由最近添加的文件 将文件插入到目录后第一个位置
          if (
            (this.name && item.name === this.name) ||
            (this.latestUploadFiles.length &&
              this.latestUploadFiles.includes(item.path))
          ) {
            res.data.splice(index, 1);
            res.data.splice(directoryCount, 0, item);
            directoryCount++;
          }
          if (!item.isDirectory) {
            item.isImg = isImg(item.path);
            item.ext = getExt(item.path);
          } else {
            item.ext = "folder";
            directoryCount++;
          }
        });
        this.tableData = res.data;
        this.newValue = JSON.stringify(res.data);
        this.arrayLength = res.data.length;
      } else {
        this.$message.error(res.message);
      }
      if (!this.isLoad) this.isLoad = true;
      hideLoading();
    },
    // 添加文件
    async addDirectoryFiles () {
      showLoading();
      const res = await fileManageApi.getDirectoryFiles({
        path: this.path,
        lastFileKey: this.lastFileKey,
      });
      if (res.code === 200) {
        this.oldValue = this.newValue;
        if (res.data.length > 0) {
          this.lastFileKey = `${this.path}${res.data[res.data.length - 1].name
            }`.substring(1);
          res.data.forEach((item) => {
            item.size = item.size - 0;
            if (!item.isDirectory) {
              item.isImg = isImg(item.path);
              item.ext = getExt(item.path);
            } else {
              item.ext = "folder";
            }
          });
          this.tableData.push(...res.data);
        }
        this.newValue = JSON.stringify(res.data);
        this.arrayLength = res.data.length;
      } else {
        this.$message.error(res.message);
      }
      if (!this.isLoad) this.isLoad = true;
      hideLoading();
    },
    // 懒加载文件  文件数量很多会很卡
    load () {
      if (
        !this.isLoad ||
        this.arrayLength < 1000 ||
        this.oldValue === this.newValue
      ) {
        return false;
      }
      this.isLoad = false;
      this.addDirectoryFiles();
      console.log("触底啦~正在加载文件中......");
    },
    closeTipsHandle () {
      this.$store.commit("config/SET_SHOW_UPLOAD_TIPS", false);
    },
  },
};
</script>

<style lang="scss">
.text-left {
  text-align: left !important;
}
.file-manage-container {
  position: relative;
  .el-upload {
    .el-upload-dragger {
      height: 100%;
      text-align: left;
      border: 0;
      border-radius: 16px;
    }
  }
  .upload-tips {
    position: absolute;
    font-size: 14px;
    left: 50%;
    top: 30px;
    transform: translateX(-50%);
  }
  .empty-image {
    background-size: contain;
    background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/empty-data.png");
  }
  .file-manage-card {
    vertical-align: middle;
    .xps-upload {
      height: 100%;
      .el-upload {
        height: 100%;
        .el-upload-dragger {
          background-color: #fff;
          border-radius: 0;
          &:hover {
            background-color: #fff;
          }
        }
      }
    }
    .file-directory-box {
      position: relative;
      .file-directory {
        display: inline-block;
        margin-right: 5px;
        color: #041677;
        font-weight: 600;
        &.link {
          cursor: pointer;
        }
        &:not(:last-child):hover {
          color: #409eff;
        }
        &.all {
          margin-right: 15px;
        }
        &.add,
        &.reading,
        &.clock,
        &.search,
        &.uploads,
        &.folder {
          position: absolute;
          top: 50%;
          right: 40px;
          transform: translateY(-50%);
          font-size: 20px;
          color: #041677;
          font-weight: 600;
        }
        &.reading {
          right: 10px;
        }
        &.add {
          right: 70px;
        }
        &.search {
          right: 160px;
        }
        &.folder {
          right: 100px;
        }
        &.uploads {
          right: 130px;
          .upload-button {
            font-size: 20px;
            color: #041677;
            &:hover {
              color: #409eff;
            }
          }
        }
        &.add:hover,
        &.reading:hover,
        &.clock:hover,
        &.search:hover,
        &.uploads:hover,
        &.folder:hover {
          color: #409eff;
        }
      }
      padding: 15px;
      border-radius: 5px;
      background-color: #fbfbfb;
    }
    .files-list {
      height: 100%;
      .el-table .el-table__body-wrapper tbody tr {
        height: 60px;
        line-height: 60px; /* 如果需要垂直居中文本，可以设置 line-height */
        overflow: hidden;
      }
      &-table {
        width: 100%;
        max-height: calc(100% - 100px);
      }
      .file-content {
        display: flex;
        justify-content: left;
        align-items: center;
        .file-image {
          display: inline-block;
          margin-right: 20px;
          width: 40px;
          max-height: 40px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          &.file-icon {
            height: 40px;
          }
        }
        .file-name {
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
